module.exports = __webpack_public_path__ + "static/favicon-1af673f139e3779638a284d5dfd5ea68.ico";